import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
// Importamos componentes MUI
import { Card, CardContent, TextField, Button, Radio, Tooltip, FormControlLabel, RadioGroup, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormLabel, CircularProgress, IconButton } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import InfoIcon from '@mui/icons-material/Info';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { createRoot } from "react-dom/client";

// Importamos el CSS para los estilos
import "./MultipleChoiceTabs.css";

// Importa el servicio con las preguntas
import { questionService, Rl, Answer } from "api/questionService";
import { FinalEvaluation, Proyecto } from "api/projectService";
import RadarChartToImage from "./RadarChartToImage";
import { enviarWordDocument, getRadarData, RadarOptions } from "api/documentService";
import { getRlLevel } from "global/util/calculadora";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


interface ModelSelectorProps {
  tabInicial: number;
  proyecto: Proyecto;
  onToggleFlag: (num?: number, inProyecto?: Proyecto) => void;
}

function MultipleChoiceTabs({ tabInicial, proyecto, onToggleFlag }: ModelSelectorProps, ref: React.Ref<unknown>) {
  const primaryBlue = "#0051A8";
  const [currentTab, setCurrentTab] = useState(0);
  const [questionGroups, setQuestionGroups] = useState<Rl[]>([]);
  const [answers, setAnswers] = useState<{ [key: string]: string[] }>({});
  const navigate = useNavigate()

  const [open, setOpen] = useState(false);
  const [openUnanswered, setOpenUnanswered] = useState(false);
  const [hasUnaswered, setHasUnswered] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingFinalizar, setLoadingFinalizar] = useState(false);

  const [respuestaFinalCrl, setRespuestaFinalCrl] = useState(proyecto.nuevaEvaluacion?.respuestaFinalCrl ?? "");
  const [respuestaFinalBrl, setRespuestaFinalBrl] = useState(proyecto.nuevaEvaluacion?.respuestaFinalBrl ?? "");
  const [respuestaFinalTrl, setRespuestaFinalTrl] = useState(proyecto.nuevaEvaluacion?.respuestaFinalTrl ?? "");
  const [respuestaFinalIprl, setRespuestaFinalIprl] = useState(proyecto.nuevaEvaluacion?.respuestaFinalIprl ?? "");
  const [respuestaFinalTmrl, setRespuestaFinalTmrl] = useState(proyecto.nuevaEvaluacion?.respuestaFinalTmrl ?? "");
  const [respuestaFinalFrl, setRespuestaFinalFrl] = useState(proyecto.nuevaEvaluacion?.respuestaFinalFrl ?? "");

  const getChileNow = (): Date => {
    const now = new Date();
    const tz = 'America/Santiago';
    const dateStr = now.toLocaleString('sv-SE', { timeZone: tz });
    return new Date(dateStr.replace(' ', 'T'));
  };

  const [selectedDate, setSelectedDate] = useState<Date>(
    proyecto.nuevaEvaluacion?.fechaEvaluacion ?? getChileNow()
  );
//  const [selectedDate, setSelectedDate] = useState<Date>(proyecto.nuevaEvaluacion?.fechaEvaluacion??new Date());

  const handleOpen = () => {
    if (proyecto.nuevaEvaluacion?.activa && !validateUnanswered()) {
        return;
      }
    if (!proyecto.nuevaEvaluacion?.activa) {
      
      if (currentTab < (questionGroups.length ?? +1)) {
        handleTabClick(currentTab + 1);
      } else {
        handleTabClick(currentTab);
      }
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseUnanswered = () => {
    setOpenUnanswered(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    handleSubmit();
  };

  useEffect(() => {
    setCurrentTab(tabInicial);
    console.log("RLs:"+JSON.stringify(proyecto.nuevaEvaluacion?.rls));
    const rls = proyecto.nuevaEvaluacion?.rls.filter(rl => rl.questions[0].answers[0].answerId!==null)
    setQuestionGroups(
      [
        { rl: 'Proyecto', name: '', description: '', preguntaFinal: '', questions: [] },
        ...rls ?? []
      ]
    );
    console.log("cuenta proyecto.nuevaEvaluacion?.rls.length ["+proyecto.nuevaEvaluacion?.rls.length+"] questionGroups.length ["+questionGroups.length+"] currentTab ["+currentTab+"]");
  }, []);

  const validateUnanswered = () => {
    return validateTab(questionGroups[currentTab]);
  }
  const validateTab = (rl: Rl) => {
    let respuestaValida = false
    if (rl.rl === 'CRL' && respuestaFinalCrl !== '') {
      respuestaValida = true;
    }
    if (rl.rl === 'BRL' && respuestaFinalBrl !== '') {
      respuestaValida = true;
    }
    if (rl.rl === 'TRL' && respuestaFinalTrl !== '') {
      respuestaValida = true;
    }
    if (rl.rl === 'IPRL' && respuestaFinalIprl !== '') {
      respuestaValida = true;
    }
    if (rl.rl === 'TmRL' && respuestaFinalTmrl !== '') {
      respuestaValida = true;
    }
    if (rl.rl === 'FRL' && respuestaFinalFrl !== '') {
      respuestaValida = true;
    }
    if (!respuestaValida || !rl.questions.every(question => question.answers.every(answer => answer.answer !== null))) {
      setOpenUnanswered(true);
      setHasUnswered(true);
      return false;
    } else {
      setOpenUnanswered(false);
      setHasUnswered(false);
      return true;
    }
  }

  const handleTabClick = async (index: number, skip?: boolean) => {
    console.log("cuenta proyecto.nuevaEvaluacion?.rls.length ["+proyecto.nuevaEvaluacion?.rls.length+"] questionGroups.length ["+questionGroups.length+"] currentTab ["+currentTab+"] index ["+index+"]");
    if(questionGroups.length<=index){
      console.log("indice inválido:"+proyecto.nuevaEvaluacion?.rls.length);
      return;
    }
    if (proyecto.nuevaEvaluacion && proyecto.nuevaEvaluacion?.activa) {
      if (!validateUnanswered()) {
        return;
      }
      if (skip) {
        console.log("saltar efecto de loading");
      } else {
        setLoading(true);
      }
      const answers: Answer[] = questionGroups[currentTab]?.questions.flatMap(
        question => question.answers
      ) || [];
      //console.log("answers----->"+JSON.stringify(answers));
      try {
        let rl = questionGroups[currentTab].rl;
        let respuesta = '';
        if (rl === 'CRL') {
          respuesta = respuestaFinalCrl ?? '';
        }
        if (rl === 'BRL') {
          respuesta = respuestaFinalBrl ?? '';
        }
        if (rl === 'TRL') {
          respuesta = respuestaFinalTrl ?? '';
        }
        if (rl === 'IPRL') {
          respuesta = respuestaFinalIprl ?? '';
        }
        if (rl === 'TmRL') {
          respuesta = respuestaFinalTmrl ?? '';
        }
        if (rl === 'FRL') {
          respuesta = respuestaFinalFrl ?? '';
        }
        await questionService.guardarEvaluacion({ id: proyecto.nuevaEvaluacion.id, rl: rl,fechaEvaluacion:selectedDate, respuestaFinal: respuesta, answers: answers });
      } catch (error) {
        console.error("Error al guardar respuestas", error);
      } finally {
        if (skip) {
          console.log("saltar efecto de loading al cierre");
        } else {
          setLoading(false);
        }
      }
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
    //console.log("saltando a tab:" + index + " --->" + questionGroups[currentTab].name + "   ----->" + questionGroups[index].name);
    setCurrentTab(index);
    handleClose();
  };

  useImperativeHandle(ref, () => ({
    handleTabClick
  }));


  const handleCheckboxChange2 = (
    answer: Answer,
    option: string,
    value: string
  ) => {
    answer.answer = value == "si";
  };

  const handleCheckboxChange = (
    groupIndex: number,
    questionIndex: number,
    option: string,
    value: string
  ) => {

    const key = `${groupIndex}-${questionIndex}`;
    setAnswers((prevState) => {
      const existing = prevState[key] || [];
      let updated: string[];
      if (existing.includes(option)) {
        updated = existing.filter((item) => item !== option);
      } else {
        updated = [...existing, option];
      }
      return { ...prevState, [key]: updated };
    });
  };

  const isChecked = (groupIndex: number, questionIndex: number, option: string) => {
    const key = `${groupIndex}-${questionIndex}`;
    return answers[key]?.includes(option);
  };

  const handleSubmit = async () => {
    if (!proyecto.nuevaEvaluacion?.activa) { return; } //si la evaluacion está inactiva no se guarda
    if (!validateUnanswered()) {
      return;
    }
    console.log("Respuestas seleccionadas:", answers);
    try {
      setLoadingFinalizar(true);
      const skip = true;
      await handleTabClick(currentTab, skip);
      if (!proyecto.nuevaEvaluacion?.activa) { return; } //si la evaluacion está inactiva no se guarda
      if (proyecto.nuevaEvaluacion) {
        //const finalizacion:FinalEvaluation = await questionService.finalizarEvaluacion(proyecto.nuevaEvaluacion);

        questionService.finalizarEvaluacion({
          ...proyecto.nuevaEvaluacion,
          respuestaFinalCrl: respuestaFinalCrl ?? '',
          respuestaFinalBrl: respuestaFinalBrl ?? '',
          respuestaFinalTrl: respuestaFinalTrl ?? '',
          respuestaFinalIprl: respuestaFinalIprl ?? '',
          respuestaFinalTmrl: respuestaFinalTmrl ?? '',
          respuestaFinalFrl: respuestaFinalFrl ?? '',
          fechaEvaluacion: selectedDate,
        }).then((eva) => {
          console.log("Evaluacion cerrada");
          //console.log(eva.graph);
          /*
          const container = document.createElement("div");
          document.body.appendChild(container);
          const root = createRoot(container);
          root.render(

            <RadarChartToImage
              radarData={getRadarData(eva)}
              radarOptions={RadarOptions}
              onImageReady={async (base64Image: string) => {
                enviarWordDocument(eva.idProyecto, base64Image);
              }} />);*/
        }).catch(err=>console.error("error al cerrar evaluacion",err));
        alert("¡Respuestas enviadas! En unos minutos recibirás el informe de resultados en tu dirección de correo electrónico.");
        navigate(`/`);

      }
    } catch (error) {
      alert("Hubo un error al enviar las respuestas. Por favor intenta denuevo más tarde.");
    } finally {
      setLoading(false);
      setLoadingFinalizar(false);
    }

  };

  return (
    <div className="containerMultipleChoiceTabs">
      <motion.div
        className="mxAuto">
        <div className="tabsHeader">
          {questionGroups.map((group, index) => (
            index === 0 ?
              <button
                key={index}
                className={
                  index === currentTab
                    ? "tabButton2 tabButtonActive2"
                    : "tabButton2"
                }
                onClick={() => onToggleFlag(index, proyecto)}
              >
                {group.rl}
              </button>
              :
              <button
                key={index}
                className={
                  index === currentTab
                    ? "tabButton2 tabButtonActive2"
                    : "tabButton2"
                }
                onClick={() => handleTabClick(index)}
              >
                {group.rl}
              </button>
          ))}

        </div>
        {/* Contenido de la pestaña actual */}
        <Card className="cardClass">
          <CardContent>
          {proyecto.nuevaEvaluacion?.activa?'Ingrese la fecha de medición del nivel de madurez. Esta fecha se utilizará para ordenar las evaluaciones y visualizar el avance del proyecto.'
          :'Fecha de medición del nivel de madurez. Esta fecha se utilizará para ordenar las evaluaciones y visualizar el avance del proyecto.'}
          
          </CardContent>
          <CardContent>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date??new Date())}
              dateFormat="dd-MM-yyyy"
              placeholderText="Selecciona una fecha"
              todayButton="Hoy"
              
              disabled={!proyecto.nuevaEvaluacion?.activa}
              customInput={<TextField label="Fecha de medición" fullWidth />}
            />
          </CardContent>
        </Card>
        {questionGroups[currentTab] ?
          <Card className="cardClass">
            <CardContent>

              {questionGroups[currentTab]?.name}
              <p>{questionGroups[currentTab].description}</p>
              {
                proyecto.nuevaEvaluacion?.activa ?
                  ('Para cada nivel selecciona "Sí" o "No" donde consideras que tu Proyecto cumple o no con lo mencionado.')
                  :
                  ("")
              }

            </CardContent>

          </Card>
          :
          ''

        }
        {questionGroups[currentTab] && (
          <div>

            {
              questionGroups[currentTab].questions.map((question, questionIndex) => (
                <div>

                  <Card key={questionIndex} className="cardClass">
                    <CardContent>
                      <h2 className="titleQuestion">Nivel {question.level} - {question.questionText} </h2>
                      <div className="gridContainer">
                        {question.answers.map((option, optionIndex) => (
                          <div>
                            <FormControl disabled={!proyecto.nuevaEvaluacion?.activa} error={option.answer === null && hasUnaswered}>
                              <FormLabel className="labelOption"><span>{option.optionText} </span></FormLabel>
                              <RadioGroup

                                row
                                value={option.answer === null ? null : option.answer ? "si" : "no"}
                                onChange={(e) => {
                                  handleCheckboxChange(currentTab, questionIndex, option.answerId + "", e.target.value);
                                  handleCheckboxChange2(option, option.answerId + "", e.target.value);
                                }
                                }
                              >
                                <FormControlLabel
                                  value="si"
                                  control={<Radio sx={{ color: primaryBlue, '&.Mui-checked': { color: primaryBlue } }} />}
                                  label="Sí"
                                />
                                <FormControlLabel
                                  value="no"
                                  control={<Radio sx={{ color: primaryBlue, '&.Mui-checked': { color: primaryBlue } }} />}
                                  label="No"
                                />
                              </RadioGroup>
                            </FormControl>

                          </div>
                        ))}

                      </div>
                    </CardContent>

                    {question.level <= getRlLevel(questionGroups[currentTab]) && question.answers.every(answer => answer.answer === null ? false : answer.answer) ?


                      <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip
                          title="Cumple nivel"
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: 'success.main', // Cambia el color de fondo a verde
                                fontSize: '1.5rem', // Duplica el tamaño del texto del tooltip
                              },
                            },
                          }}
                        >
                          <CheckCircleOutlineIcon sx={{ marginLeft: 'auto', padding: 1, color: 'success.main' }} />
                        </Tooltip>
                      </CardContent>
                      :
                      <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip
                          title="Nivel por mejorar"
                          componentsProps={{
                            tooltip: {
                              sx: {

                                fontSize: '1.5rem', // Duplica el tamaño del texto del tooltip
                              },
                            },
                          }}
                        >
                          <InfoIcon sx={{ marginLeft: 'auto', padding: 1 }} />
                        </Tooltip>
                      </CardContent>
                    }



                  </Card>
                </div>
              ))}



            <Card className="cardClass">
              <CardContent>
                <h2 className="titleQuestion">Pregunta abierta</h2>
                <div className="gridContainer">{

                  (() => {
                    //console.log("DEBUG -> questionGroups[currentTab]:", questionGroups[currentTab]);
                    return questionGroups[currentTab].preguntaFinal;
                  })()
                }
                  {
                    (() => {
                      if (questionGroups[currentTab].rl === 'CRL') {
                        return <TextField value={respuestaFinalCrl}
                          onChange={(e) => setRespuestaFinalCrl(e.target.value)}
                          required fullWidth type="text" label="Responder pregunta abierta" sx={{ mb: 1 }} multiline rows={2}
                          disabled={!proyecto.nuevaEvaluacion?.activa}
                          inputProps={{ maxLength: 1000 }} />
                      }
                      if (questionGroups[currentTab].rl === 'BRL') {
                        return <TextField value={respuestaFinalBrl}
                          onChange={(e) => setRespuestaFinalBrl(e.target.value)}
                          required fullWidth type="text" label="Responder pregunta abierta" sx={{ mb: 1 }} multiline rows={2}
                          disabled={!proyecto.nuevaEvaluacion?.activa}
                          inputProps={{ maxLength: 1000 }} />
                      }
                      if (questionGroups[currentTab].rl === 'TRL') {
                        return <TextField value={respuestaFinalTrl}
                          onChange={(e) => setRespuestaFinalTrl(e.target.value)}
                          required fullWidth type="text" label="Responder pregunta abierta" sx={{ mb: 1 }} multiline rows={2}
                          disabled={!proyecto.nuevaEvaluacion?.activa}
                          inputProps={{ maxLength: 1000 }} />
                      }
                      if (questionGroups[currentTab].rl === 'IPRL') {
                        return <TextField value={respuestaFinalIprl}
                          onChange={(e) => setRespuestaFinalIprl(e.target.value)}
                          required fullWidth type="text" label="Responder pregunta abierta" sx={{ mb: 1 }} multiline rows={2}
                          disabled={!proyecto.nuevaEvaluacion?.activa}
                          inputProps={{ maxLength: 1000 }} />
                      }
                      if (questionGroups[currentTab].rl === 'TmRL') {
                        return <TextField value={respuestaFinalTmrl}
                          onChange={(e) => setRespuestaFinalTmrl(e.target.value)}
                          required fullWidth type="text" label="Responder pregunta abierta" sx={{ mb: 1 }} multiline rows={2}
                          disabled={!proyecto.nuevaEvaluacion?.activa}
                          inputProps={{ maxLength: 1000 }} />
                      }
                      if (questionGroups[currentTab].rl === 'FRL') {
                        return <TextField value={respuestaFinalFrl}
                          onChange={(e) => setRespuestaFinalFrl(e.target.value)}
                          required fullWidth type="text" label="Responder pregunta abierta" sx={{ mb: 1 }} multiline rows={2}
                          disabled={!proyecto.nuevaEvaluacion?.activa}
                          inputProps={{ maxLength: 1000 }} />
                      } else {
                        return <></>
                      }
                    })()

                  }







                </div>
              </CardContent>
            </Card>
          </div>


        )}



        <div className="submitButtonContainer">

          <Button
            type="submit"
            variant="contained"
            onClick={handleOpen}
            className="app-primary-button"
          >
            Continuar
          </Button>



        </div>
      </motion.div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        PaperProps={{
          className: "evaluation-confirmation-modal",
        }}
      >
        <DialogTitle
          id="modal-title"
          className="evaluation-confirmation-modal__title"
        >
          <InfoOutlinedIcon
            aria-hidden="true"
            className="evaluation-confirmation-modal__icon"
          />
          <span className="evaluation-confirmation-modal__title-text">Confirmación</span>
          <IconButton
            aria-label="Cerrar"
            onClick={handleClose}
            size="small"
            className="evaluation-confirmation-modal__close"
          >
            <CloseIcon className="evaluation-confirmation-modal__close-icon" />
          </IconButton>
        </DialogTitle>
        <DialogContent className="evaluation-confirmation-modal__content">
          <DialogContentText className="evaluation-confirmation-modal__text">
            {currentTab < (questionGroups.length -1) ? <>Tu nivel actual de {questionGroups[currentTab]?.name} es <b>{getRlLevel(questionGroups[currentTab])}</b>.</> : ''}
            {currentTab < (questionGroups.length -1) ? '' : <>Tu nivel actual de {questionGroups[1]?.name} es <b>{getRlLevel(questionGroups[1])}</b>.<br></br></>}
            {currentTab < (questionGroups.length -1) ? '' : <>Tu nivel actual de {questionGroups[2]?.name} es <b>{getRlLevel(questionGroups[2])}</b>.<br></br></>}
            {currentTab < (questionGroups.length -1) ? '' : <>Tu nivel actual de {questionGroups[3]?.name} es <b>{getRlLevel(questionGroups[3])}</b>.<br></br></>}
            {currentTab < (questionGroups.length -1) ? '' : <>Tu nivel actual de {questionGroups[4]?.name} es <b>{getRlLevel(questionGroups[4])}</b>.<br></br></>}
            {currentTab < (questionGroups.length -1) ? '' : <>Tu nivel actual de {questionGroups[5]?.name} es <b>{getRlLevel(questionGroups[5])}</b>.<br></br></>}
            {currentTab < (questionGroups.length -1) ? '' : questionGroups.length===7? <>Tu nivel actual de {questionGroups[6]?.name} es <b>{getRlLevel(questionGroups[6])}</b>.<br></br></>:''}

            {currentTab < (questionGroups.length -1) ?
              <span> Presiona <b>Cancelar</b> para seguir revisando tus respuestas o <b>Guardar</b> para continuar con la siguiente dimensión.</span>
              : <span> Presiona <b>Cancelar</b> para seguir revisando tus respuestas, <b>Guardar</b> para conservar tus respuestas y seguir revisando más adelante, o <b>Finalizar</b> para enviar tu evaluación.</span>}


          </DialogContentText>
        </DialogContent>
        <DialogActions className="evaluation-confirmation-modal__actions">
          <Button
            disabled={loading}
            onClick={handleClose}
            color="secondary"
            className="evaluation-confirmation-modal__button evaluation-confirmation-modal__button--text"
          >
            Cancelar
          </Button>
          {

            currentTab < (questionGroups.length -1) ?
              <Button
                disabled={loadingFinalizar}
                type="submit"
                variant="contained"
                onClick={() => handleTabClick(currentTab + 1)}
                className="app-primary-button evaluation-confirmation-modal__button evaluation-confirmation-modal__button--primary"
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Guardar y continuar"}
              </Button>
              :
              <Button disabled={loadingFinalizar} type="submit" variant="contained" className="app-primary-button evaluation-confirmation-modal__button evaluation-confirmation-modal__button--primary" color="primary" onClick={() => handleTabClick(currentTab)}>
                {loading ? <CircularProgress size={24} color="inherit" /> : "Guardar"}
              </Button>
          }
          {

            currentTab < (questionGroups.length - 1) ?
              ''
              :
              <Button disabled={loading} type="submit" variant="contained" color="primary" onClick={handleSubmit} className="app-primary-button evaluation-confirmation-modal__button evaluation-confirmation-modal__button--primary" >
                {loadingFinalizar ? <CircularProgress size={24} color="inherit" /> : "Finalizar"}
              </Button>
          }
        </DialogActions>
      </Dialog>

      <Dialog open={openUnanswered} onClose={handleCloseUnanswered}>
        <DialogTitle><AnnouncementIcon /> Atención</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Para poder avanzar primero debes responder todas las preguntas con un "Si" o un "No", y escribir tu respuesta a la última pregunta.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUnanswered} color="secondary" className="app-primary-button">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default forwardRef(MultipleChoiceTabs);
